// modules
import { createAction } from 'redux-actions'

export const setFacilityList = createAction('SET_FACILITY_LIST')
export const setFloorList = createAction('SET_FLOOR_LIST')
export const setRoomList = createAction('SET_ROOM_LIST')

export const setFacilityEditValue = createAction('SET_FACILITY_EDIT_VALUE')
export const setFloorEditValue = createAction('SET_FLOOR_EDIT_VALUE')
export const setRoomEditValue = createAction('SET_ROOM_EDIT_VALUE')

export const resetFacilityManagement = createAction('RESET_FACILITY_MANAGEMENT')
